<div class="enter-password">
  <div class="content">
    <div
      [ngClass]="{ 'is-lock': icon === 'lock', 'is-unlock': icon === 'unlock' }"
      class="lock-icon"
    ></div>
    <div class="pin-container">
      <ui-pin-input
        (pinChange)="onEnter($event)"
        [hasError]="hasError"
        description="{{ 'INSERT_PASSWORD' | translate }}"
        type="PIN"
        value="password"
      ></ui-pin-input>
    </div>
    <div class="error">
      @if (wrongPassword) {
        <span class="text-onback-error">
          {{ 'WRONG_PASSWORD' | translate }}
        </span>
      }
    </div>

    @if (pendingRequest) {
      <div class="spinner">
        <ngx-spinner
          size="md"
          color="primary"
        ></ngx-spinner>
      </div>
    }
  </div>
</div>
